import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './user_profile.css'

import { UserService, FollowUserService } from '../../service'

class UserProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userByHandle: {},
      isFollowing: false
    };

    this.followUser = this.followUser.bind(this);
  }

  async componentDidMount() {
    const { user } = this.props;
    const userHandle = this.getUserHandleIdFromUrl();
    const userByHandle = await UserService.getUserByHandleId(userHandle);
    const isFollowingResult = await FollowUserService.isFollowingUser(user.user_id, userByHandle.id);
    const isFollowingUser = isFollowingResult.data.is_following;
    this.setState({ userByHandle: userByHandle })
    this.setState({ isFollowing: isFollowingUser })
  }

  getUserHandleIdFromUrl() {
    const { pathname } = window.location;
    const [str, userHandle] = pathname.match(/\/user-profile\/([a-zA-Z0-9_]+)/);
    return userHandle;
  }

  async followUser() {
    const followData = {
      followee: this.state.userByHandle.id,
      is_follow: !this.state.isFollowing
    }
    const response = await FollowUserService.followUser(followData);
    if (response.status == 200) {
      this.setState({ isFollowing: !this.state.isFollowing })
    }
  }

  render() {
    return (
      <div class="padding">
        <div class="col-md-8">
          <div class="card">
            <img class="card-img-top" src="https://www.teahub.io/photos/full/90-906297_scenic-backgrounds.jpg" alt="Card image cap" />
            <div class="card-body little-profile text-center">
              <div class="pro-img"><img src={this.state.userByHandle.image_url} alt="user" /></div>
              <h3 class="m-b-0">{this.state.userByHandle.name}</h3>
              <p>{this.state.userByHandle.bio}</p>
              <a onClick={this.followUser} class="btn btn-primary btn-md btn-rounded" >{this.state.isFollowing ? "Unfollow" : "Follow"}</a>
              <div class="row text-center m-t-20">
                <div class="col-lg-4 col-md-4 m-t-20">
                  <h3 class="m-b-0 font-light">123K</h3><small>Post</small>
                </div>
                <div class="col-lg-4 col-md-4 m-t-20">
                  <h3 class="m-b-0 font-light">{this.state.userByHandle.follow_data && this.state.userByHandle.follow_data.follower_count}</h3><small>Followers</small>
                </div>
                <div class="col-lg-4 col-md-4 m-t-20">
                  <h3 class="m-b-0 font-light">{this.state.userByHandle.follow_data && this.state.userByHandle.follow_data.followee_count}</h3><small>Following</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

UserProfile.propTypes = {
  user: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
